module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('smallBar', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "material-table-widget dashboard_top_bar"
  }, [_c('button', {
    staticClass: "btn btn-default btn-new",
    on: {
      "click": function($event) {
        _vm.CreateCategoryModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增任務類型")])]), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_vm._m(1), _vm._v(" "), _c('draggable', {
    staticClass: "dragArea full-width text-left product_drag_area",
    attrs: {
      "options": _vm.dragOptions,
      "move": _vm.getDraggedData
    },
    on: {
      "change": function($event) {
        _vm.onChange($event, null)
      }
    },
    model: {
      value: (_vm.activity_categories),
      callback: function($$v) {
        _vm.activity_categories = $$v
      },
      expression: "activity_categories"
    }
  }, [_c('transition-group', {
    staticClass: "product_drag_area",
    attrs: {
      "type": "transition",
      "tag": "div"
    }
  }, _vm._l((_vm.orderedCategories), function(category) {
    return _c('div', {
      key: category.order,
      staticClass: "row draggable_product",
      attrs: {
        "id": category.id
      }
    }, [_c('div', {
      staticClass: "col-xs-8"
    }, [_c('i', {
      class: category.icon
    }), _vm._v(" " + _vm._s(category.title) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 text-right"
    }, [_c('a', {
      staticClass: "row-edit",
      on: {
        "click": function($event) {
          _vm.EditCategory(category)
        }
      }
    }, [_c('span', {
      staticClass: "zmdi zmdi-edit"
    })]), _vm._v(" "), _c('a', {
      staticClass: "row-edit",
      on: {
        "click": function($event) {
          _vm.DeleteCategoryModal = true;
          _vm.delete_category = category
        }
      }
    }, [_c('span', {
      staticClass: "zmdi zmdi-close"
    })])])])
  }))], 1)], 1)])])])])])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  }), _vm._v(" "), (_vm.CreateCategoryModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.CreateCategoryModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.CreateCategoryModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.CreateCategoryModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group j-forms"
  }, [_c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("類型名稱*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_category.title),
      expression: "temp_category.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:true'),
      expression: "'required:true'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "類型名稱*",
      "name": "title"
    },
    domProps: {
      "value": (_vm.temp_category.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_category.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入類型名稱")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group j-forms"
  }, [_c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("任務Icon*："), (_vm.temp_category.icon != '') ? _c('i', {
    class: _vm.temp_category.icon
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:true'),
      expression: "'required:true'"
    }],
    ref: "picker",
    staticClass: "form-control",
    attrs: {
      "name": "icon",
      "type": "text",
      "placeholder": "點擊來選擇icon，可用英文關鍵字過濾icon，ex: dinner"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('icon')),
      expression: "errors.has('icon')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('icon')),
      expression: "errors.has('icon')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入選擇一個icon")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "icon-preview-fade"
    }
  }, [(_vm.focusOn) ? _c('div', {
    staticClass: "preview-container"
  }, [_c('div', {
    class: ['previewer', 'rounded', {
      'custom-shadow-sm': !_vm.hoverPanel
    }, {
      'custom-shadow': _vm.hoverPanel
    }],
    on: {
      "click": function($event) {
        _vm.select(undefined)
      },
      "mouseover": function($event) {
        _vm.hoverPanel = true
      },
      "mouseout": function($event) {
        _vm.hoverPanel = false
      }
    }
  }, _vm._l((_vm.iconsFiltered), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "icon-preview"
    }, [_c('div', {
      class: ['icon-wrapper', 'rounded', 'shadow-sm', {
        selected: i.title == _vm.selected
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.select(i)
        }
      }
    }, [_c('i', {
      class: i.title
    })])])
  }))]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.CreateCategory()
      }
    }
  }, [_vm._v("\n                建立\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.CreateCategoryModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.UpdateCategoryModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.UpdateCategoryModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.UpdateCategoryModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.UpdateCategoryModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group j-forms"
  }, [_c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("類型名稱*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update_category.title),
      expression: "update_category.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:true'),
      expression: "'required:true'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "類型名稱*",
      "name": "title"
    },
    domProps: {
      "value": (_vm.update_category.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.update_category.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入類型名稱")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group j-forms"
  }, [_c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("任務Icon*："), (_vm.update_category.icon != '') ? _c('i', {
    class: _vm.update_category.icon
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:true'),
      expression: "'required:true'"
    }],
    ref: "picker",
    staticClass: "form-control",
    attrs: {
      "name": "icon",
      "type": "text",
      "placeholder": "點擊來選擇icon，可用英文關鍵字過濾icon，ex: dinner"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('icon')),
      expression: "errors.has('icon')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('icon')),
      expression: "errors.has('icon')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入選擇一個icon")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "icon-preview-fade"
    }
  }, [(_vm.focusOn) ? _c('div', {
    staticClass: "preview-container"
  }, [_c('div', {
    class: ['previewer', 'rounded', {
      'custom-shadow-sm': !_vm.hoverPanel
    }, {
      'custom-shadow': _vm.hoverPanel
    }],
    on: {
      "click": function($event) {
        _vm.select(undefined)
      },
      "mouseover": function($event) {
        _vm.hoverPanel = true
      },
      "mouseout": function($event) {
        _vm.hoverPanel = false
      }
    }
  }, _vm._l((_vm.iconsFiltered), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "icon-preview"
    }, [_c('div', {
      class: ['icon-wrapper', 'rounded', 'shadow-sm', {
        selected: i.title == _vm.selected
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.select(i)
        }
      }
    }, [_c('i', {
      class: i.title
    })])])
  }))]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.UpdateCategory()
      }
    }
  }, [_vm._v("\n                更新\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.UpdateCategoryModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.DeleteCategoryModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.DeleteCategoryModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.DeleteCategoryModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h4', [_vm._v("你確定要刪除此類型？ "), _c('i', {
    class: _vm.delete_category.icon
  }), _vm._v(" " + _vm._s(_vm.delete_category.title))])]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.DeleteCategoryModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.DeleteCategory(_vm.delete_category)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" 確定刪除\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.DeleteCategoryModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h3', [_vm._v("任務設定")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-info"
  }, [_vm._v("您可以在此自訂各種行事曆任務類型，之後建立行事曆內的代辦事項，可以選擇新的事項類型"), _c('br'), _vm._v("業務的統計數據，也會顯示這些類型的資訊唷！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h4', [_vm._v("新增任務類型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h4', [_vm._v("編輯任務類型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "alert alert-info"
  }, [_vm._v("刪除類型，並不會刪除該類型的所有待辦事項")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a1015d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/ActivityCategories.vue
// module id = 684
// module chunks = 4